// Dark-surface tokens used across the video builder (match the designer).
export const vb = {
  surface: '#1C1C1C',
  page: '#151515',
  border: '#2A2A2A',
  borderStrong: '#444444',
  text: '#FDFDFD',
  textSecondary: '#B6B6B6',
  textTertiary: '#868686',
  brand: '#F79420',
  brandDark: '#F15A26',
  gradient: 'linear-gradient(180deg, #F79420 0%, #F15A26 100%)',
  danger: '#FF6B6B',
  success: '#7BD88F',
  font: 'Inter, sans-serif'
} as const;

export const fieldSx = {
  '& .MuiOutlinedInput-root': {
    color: vb.text,
    fontFamily: vb.font,
    fontSize: 14,
    background: vb.page,
    '& fieldset': { borderColor: vb.border },
    '&:hover fieldset': { borderColor: vb.borderStrong },
    '&.Mui-focused fieldset': { borderColor: vb.brand }
  },
  '& .MuiInputBase-input::placeholder': { color: vb.textTertiary, opacity: 1 }
} as const;

export const labelSx = {
  fontFamily: vb.font,
  fontSize: 11,
  fontWeight: 800,
  letterSpacing: '0.12em',
  textTransform: 'uppercase' as const,
  color: vb.textTertiary,
  mb: 0.75
};

export const pillButtonSx = (primary = false) => ({
  fontFamily: vb.font,
  fontSize: 13,
  fontWeight: 700,
  textTransform: 'none' as const,
  borderRadius: '8px',
  px: 2,
  py: 0.9,
  // House button: white text on the gradient; disabled is dark with dim text.
  color: primary ? '#FDFDFD' : vb.text,
  background: primary ? vb.gradient : '#1C1C1C',
  border: primary ? 'none' : '1px solid #2A2A2A',
  '&:hover': { opacity: 0.9, background: primary ? vb.gradient : '#262626' },
  '&.Mui-disabled': primary
    ? { opacity: 1, background: 'rgba(0, 0, 0, 0.2)', color: '#565656', boxShadow: 'inset 0 0 0 1px #2A2A2A' }
    : { opacity: 1, color: '#565656', borderColor: '#2A2A2A' }
});
